import { useEffect, useState } from 'react';

import { googleAnalyticsConfig } from '../../../config/googleAnalyticsConfig';
import { useTagCommander } from '../useTagCommander/useTagCommander';
import { ensureGAScriptAdded } from './ensureGAScriptAdded';
import { isGaScriptLoaded } from './isGaScriptLoaded';
import { removeGAScript } from './removeGAScript';

/* Be sure you place it once in the application */
export const useGoogleAnalyticsScript = (activated: boolean) => {
  /* app hooks */
  const { selectedPrivacyCategories } = useTagCommander();

  /* local states */
  const [enabled, setEnabled] = useState<boolean>(false);

  /* enable/disable GA */
  useEffect(() => {
    if (activated) {
      setEnabled(
        selectedPrivacyCategories.some(
          (c) => c === googleAnalyticsConfig.tagCommanderCategoryForGa,
        ),
      );
    }
  }, [selectedPrivacyCategories, activated]);

  // as an alternative (not tested): window['ga-disable-GA_MEASUREMENT_ID'] = true;
  useEffect(() => {
    if (enabled) {
      ensureGAScriptAdded((value) => isGaScriptLoaded.set(value));
    } else {
      removeGAScript();
      console.log(`GA disabled for "${googleAnalyticsConfig.gaMeasurementId}"`);
    }
  }, [enabled]);
};
